var React = require( 'react' );
var createReactClass = require('create-react-class');
var moment = require('moment');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var DateFormat = createReactClass({
    mixins: [PureRenderMixin],

    render: function(){
        return <span>{moment(this.props.date || new Date()).format(this.props.format || 'MMM DD YYYY')}</span>;
    }
});

module.exports = DateFormat;



// WEBPACK FOOTER //
// ./src/common/routes/components/dateFormat.jsx